import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export function BlankLayout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
